// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper___QBYv2","flex":"flex___TGMce","label":"label___2VWvV","full":"full___3T1Y5"};